import { values } from "lodash";
import { getHeaderSimple, getHeaderMultipart } from "./utils";
import axios from 'axios';

export const getStudies = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}studyType/`, {
        method: "GET",
        headers: getHeaderSimple(),
    });
    const json = await response.json();

    if (json.message === "Ok") {
        return {
            status: "Ok",
            message: "Ok",
            content: json.data,
        };
    } else {
        return {
            status: "Error",
            message: json.content ?? "Error de conexión"
        }
    }
};

export const addItem = async (values) => {

    const formData = new FormData();
    formData.append("name", values?.name);
    formData.append("status", values?.status);

    const result = await axios({
        method: 'post',
        url: `${process.env.REACT_APP_API_URL}studyType/`,
        data: formData,
        headers: getHeaderSimple(),
    })

    if (result.data?.message === "Ok") {
        return {
            status: "Ok",
            message: "Ok",
        };
    } else {
        return {
            status: "Error",
            message: result.data?.message ?? "No se pudo crear el estudiante",
        };
    }
}

export const getOne = async (id) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}studyType/${id}`, {
        method: "GET",
        headers: getHeaderSimple(),
    });
    const json = await response.json();

    if (json.data) {
        return {
            status: "Ok",
            message: "Ok",
            content: json.data,
        };
    } else {
        return {
            status: "Error",
            message: json.content ?? "Error de conexión"
        }
    }
};

export const updateOne = async (id, values) => {

    const formData = new FormData();
    formData.append("name", values?.name);
    formData.append("status", values?.status);

    const result = await axios({
        method: 'put',
        url: `${process.env.REACT_APP_API_URL}studyType/${id}`,
        data: formData,
        headers: getHeaderMultipart(),
    })

    if (result.data?.message === "Ok") {
        return {
            status: "Ok",
            message: "Ok",
        };
    } else {
        return {
            status: "Error",
            message: result.data?.message ?? "No se pudo editar el estudiante",
        };
    }
}

export const dropOne = async (id) => {

    const result = await axios({
        url: `${process.env.REACT_APP_API_URL}studyType/${id}`,
        method: "DELETE",
        headers: getHeaderSimple(),
    });

    if (result.data?.message === "Ok") {
        return {
            status: "Ok",
            message: "Ok",
        };
    } else {
        return {
            status: "Error",
            message: result.data?.message ?? "No se pudo eliminar el estudiante",
        };
    }
}

export const searchItem = async (search) => {

    const response = await fetch(`${process.env.REACT_APP_API_URL}studyType/search/${search}`, {
        method: "GET",
        headers: getHeaderSimple(),
    });
    const json = await response.json();

    if (json.data) {
        return {
            status: "Ok",
            message: "Ok",
            content: json.data,
        };
    } else {
        return {
            status: "Error",
            message: json.content ?? "Error de conexión"
        }
    }
}

export const getStatus = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}generalstatus/`, {
        method: "GET",
        headers: getHeaderSimple(),
    });
    const json = await response.json();

    if (json.message === "Ok") {
        return {
            status: "Ok",
            message: "Ok",
            content: json.data,
        };
    } else {
        return {
            status: "Error",
            message: json.content ?? "Error de conexión"
        }
    }
}